import { Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

export const PageTitle = styled(Title)`
  && {
    padding: 16px, 16px, 16px, 0px;
  }
`;
